/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipmentAddressDto } from '../../models/shipment-address-dto';

export interface GetLastOrderedShipmentAddress$Params {
}

export function getLastOrderedShipmentAddress(http: HttpClient, rootUrl: string, params?: GetLastOrderedShipmentAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentAddressDto>> {
  const rb = new RequestBuilder(rootUrl, getLastOrderedShipmentAddress.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipmentAddressDto>;
    })
  );
}

getLastOrderedShipmentAddress.PATH = '/api/v1/order/last-ordered-address';
